import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert Date object to "YYYY-MM-DD" string
 *
 * wrapper around DatePipe.transform() with stricter ts interface
 *
 * https://en.wikipedia.org/wiki/ISO_8601
 */
@Pipe({
  standalone: true,
  name: 'isoDate'
})
export class IsoDatePipe implements PipeTransform {
  transform(date: Date, format = 'yyyy-MM-dd', locale = 'en-US', timezone?: string | undefined): string {
    return new DatePipe(locale).transform(date, format, timezone) || "";  // DatePipe may return undef
  }
}
